import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const analyticSelector = (state: State) => state.analytic.data;
export const analyticStatusSelector = (state: State) => state.analytic.status;
export const analyticLoadedSelector = isLoaded(analyticStatusSelector);
export const shouldLoadAllListCompanySelector = shouldLoad(
  analyticStatusSelector,
);
export const analyticRejectedSelector = isRejected(analyticStatusSelector);
export const analyticPendingSelector = isPending(analyticStatusSelector);
